import { render, staticRenderFns } from "./bo-related-categories.vue?vue&type=template&id=0f1ade43"
import script from "./bo-related-categories.vue?vue&type=script&lang=js"
export * from "./bo-related-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports